import { shape, number, string, arrayOf, instanceOf, bool } from 'prop-types'

export const typeBookingInformation = shape({
  adults: string,
  boardCode: string,
  boardName: string,
  bookingDate: string,
  checkIn: string,
  checkOut: string,
  children: string,
  childrenAges: string,
  comments: string,
  holder: string,
  idBooking: number,
  insurance: instanceOf(Object),
  internal: number,
  isCancellable: bool,
  nights: number,
  rateName: string,
  roomName: string,
  specialRequests: arrayOf(
    shape({
      requestKey: string,
      requestValue: string,
    })
  ),
  cancellationPolicies: arrayOf(
    shape({
      cancellationDate: string,
      amount: number,
      currency: string,
    })
  ),
  ticketsPaid: arrayOf(
    shape({
      idTicket: number,
      total: number,
      currency: string,
      paymentStatus: string,
      paymentType: string,
      paymentDate: string,
    })
  ),
})

export const typePriceSummary = shape({
  priceSummary: shape({
    bookingId: number,
    currency: string,
    total: number,
    pendingAmount: number,
    wallet: number,
    insurance: number,
    taxes: number,
    subtotal: number,
    price: number,
    additionalFees: arrayOf(
      shape({
        amount: number,
        currency: string,
      })
    ),
  }),
})

export const typeHotelPreview = shape({
  hotelPreview: shape({
    propertyId: string,
    propertyAddress: string.isRequired,
    propertyName: string.isRequired,
    propertyStars: number,
    propertyImages: arrayOf(
      shape({
        path: string,
        source: string,
        code: string,
        bookingIdRoom: string,
      })
    ),
    conditions: shape({
      checkin: instanceOf(Object),
      checkout: instanceOf(Object),
      fees: instanceOf(Object),
      policies: instanceOf(Object),
    }),
  }),
})

export const typeVoucher = shape({
  bookingInformation: arrayOf(typeBookingInformation),
  currency: string,
  hotelPreview: typeHotelPreview,
  nights: number.isRequired,
  priceSummary: typePriceSummary,
  rooms: number,
})
